import React, { createContext, useState, useEffect, useContext } from 'react';
import { Navigate } from 'react-router-dom';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState(null); // Agrega el estado para el nombre de usuario
  const [idUser, setIdUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedToken = sessionStorage.getItem('token');
    const savedUsername = sessionStorage.getItem('name'); // Obtén el nombre de usuario del almacenamiento local
    if (savedToken) {
      setToken(savedToken);
      setUsername(savedUsername); // Establece el nombre de usuario almacenado
    }
    setLoading(false);
  }, []);

  const login = (newToken) => {
    setToken(newToken);
    sessionStorage.setItem('token', newToken);
  };

  const logout = () => {
    setToken(null);
    sessionStorage.removeItem('token');
  };
  


  return (
    <AuthContext.Provider value={{ token, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};

export function RequireAuth({ children }) {
  const token = sessionStorage.getItem('token');

  if (!token) {
    return <Navigate to="/login" />;
  }
  return children;
}